import { Button, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { FadeOutSpacer, IconContainer } from '../components';
import { ICON_CONTAINER_WIDTH, TRANSITION_SETTINGS } from '../config';
const BUTTON_WIDTH = pxToRem(40);
const BUTTON_TRANSLATE = `calc((${BUTTON_WIDTH} - ${ICON_CONTAINER_WIDTH}) / 2 * -1)`;
export const StyledButton = styled(Button) `
  justify-content: flex-start;
  min-width: ${BUTTON_WIDTH};
  width: 100%;
  padding: 0;
  gap: 0;
  transform: translateX(0);

  transition: all ${TRANSITION_SETTINGS};

  ${(props) => props.$minimized &&
    `
    transform: translateX(${BUTTON_TRANSLATE});
  `}
`;
export const StyledIconContainer = styled(IconContainer) `
  min-width: ${BUTTON_WIDTH};
`;
export const StyledFadeOutSpacer = styled(FadeOutSpacer) `
  padding-right: ${themeGet('spacing.md')};
`;
